import React from "react";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { Button, Input } from "antd";
import "../styles/components/json-input.scss";

class JsonInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      key: this.props.headKey ? this.props.headKey : "",
      value: this.props.headValue ? this.props.headValue : ""
    };
  }

  remove = () => {
    this.props.remove(this.props.index);
  };

  add = e => {
    e.preventDefault();
    this.props.add();
  };

  onKeyChange = e => {
    const key = e.target.value;
    this.props.changeJsonValue({ [key]: this.state.value }, this.props.index);
    this.setState(() => ({ key }));
  };

  onValueChange = e => {
    const value = e.target.value;
    this.props.changeJsonValue({ [this.state.key]: value }, this.props.index);
    this.setState(() => ({ value }));
  };

  render() {
    return (
      <div className="form-header-object--row">
        <Input
          id="header"
          name="header"
          type="text"
          placeholder="Key"
          className="form-header-object--input"
          value={this.state.key}
          onChange={this.onKeyChange}
        />
        <Input
          type="text"
          placeholder="Value"
          className="form-header-object--input"
          value={this.state.value}
          onChange={this.onValueChange}
        />
        <Button
          type={this.props.isLast ? "default" : "danger"}
          shape="circle"
          icon={this.props.isLast ? <PlusOutlined /> : <DeleteOutlined />}
          onClick={this.props.isLast ? this.add : this.remove}
          className="form-header-object--button"
        />
      </div>
    );
  }
}

export default JsonInput;
